import { useInvoiceDetailStore } from "../../store";
import { ProjectItem } from "./ProjectItem";

export const ProjectsList = () => {
  const store = useInvoiceDetailStore();

  if (!store.invoice?.projects.length) return null;

  return (
    <div>
      {store.invoice.projects.map((p) => (
        <ProjectItem key={p.id} id={p.id} code={p.code} title={p.title} />
      ))}
    </div>
  );
};
